import React from "react";
import { StatusIcon } from './status-indicator.styles';

const StatusIndicator = ({ status }) => <StatusIcon $status={status} />;

export default StatusIndicator;
